import axios from "axios"
import { getConfig } from "../../utils/config"

const config = getConfig()

export function login(credentials) {
    return axios({ "url": `${config.api.baseUrl}/api/token/`, "method": "POST", data: credentials })
}


// WEBPACK FOOTER //
// ./src/api/auth/index.js